import { request } from "../cmmdApi/transport";

export type CmmdForgeRuntimeLifecycleAction = "start" | "stop" | "recycle";

export interface CmmdForgeRuntimeApiConfig {
  readonly cmmdHttpBaseUrl: string;
  readonly accessToken?: string | null;
  readonly resolveAccessToken?: () => string | null | undefined;
  readonly listUrl?: string;
  readonly eventsUrl?: string;
  readonly destroyUrl?: (runtimeId: string) => string;
  readonly lifecycleUrl?: (runtimeId: string, action: CmmdForgeRuntimeLifecycleAction) => string;
  readonly updateCommitUrl?: (runtimeId: string) => string;
  readonly updateCommitOperationUrl?: (runtimeId: string, operationId: number) => string;
  readonly ensureUrl?: string;
  readonly cloudProjectRemovalUrl?: (cmmdProjectId: number) => string;
  readonly cloudProjectRemovalPreviewUrl?: (cmmdProjectId: number) => string;
  readonly cloudProjectRemovalReceiptUrl?: (operationId: string) => string;
}

function resolveCmmdUrl(baseUrl: string, path: string): string {
  const url = new URL(baseUrl);
  url.pathname = path;
  url.search = "";
  url.hash = "";
  return url.toString();
}

export function ensureBearer(config: CmmdForgeRuntimeApiConfig): string | null | undefined {
  return config.accessToken ?? config.resolveAccessToken?.();
}

export function requestRuntime<T>(
  config: CmmdForgeRuntimeApiConfig,
  input: {
    readonly method: "GET" | "POST" | "DELETE";
    readonly path: string;
    readonly body?: unknown;
    readonly signal?: AbortSignal;
  },
  resolveUrl: (path: string) => string = (path) => resolveCmmdUrl(config.cmmdHttpBaseUrl, path),
): Promise<T> {
  return request<T>(
    {
      method: input.method,
      path: input.path,
      ...(input.body !== undefined ? { body: input.body } : {}),
      ...(input.signal !== undefined ? { signal: input.signal } : {}),
    },
    {
      resolveUrl,
      resolveBearerToken: () => ensureBearer(config),
    },
  );
}
